/* FIX-GA4-COLLECTION-FUNNEL-20260714
 * Completes the GA4 ecommerce collection funnel through Shopify's app-owned Google tag.
 * Sends view_item_list and select_item only to GA4; Google Ads and Merchant Center are untouched.
 */
(function () {
  "use strict";

  var GA4_TAG_ID = "G-VFP89NK7X8";
  var STATE_KEY = "__elGa4CollectionFunnel20260714";
  var state = window[STATE_KEY] = window[STATE_KEY] || {
    listScheduled: false,
    listSent: false,
    lastSelectionPath: "",
    lastSelectionAt: 0
  };

  function hasDataLayerEvent(eventName) {
    var layer = Array.isArray(window.dataLayer) ? window.dataLayer : [];
    for (var index = 0; index < layer.length; index += 1) {
      var entry = layer[index];
      if (!entry) continue;
      if (entry.event === eventName) return true;
      if (entry[0] === "event" && entry[1] === eventName) return true;
    }
    return false;
  }

  function cleanText(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function productName(product, variant) {
    var name = cleanText(variant && variant.name);
    var variantName = cleanText(variant && variant.public_title);
    if (variantName && name.slice(-(variantName.length + 3)) === " - " + variantName) {
      name = name.slice(0, -(variantName.length + 3));
    }
    return name || cleanText(product && product.handle).replace(/-/g, " ");
  }

  function currentContext() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var page = meta && meta.page;
    var products = meta && Array.isArray(meta.products) ? meta.products : [];
    if (!page || page.pageType !== "collection" || !products.length) return null;

    var heading = document.querySelector("main h1, h1");
    var listName = cleanText(heading && heading.textContent) || cleanText(document.title.split("|")[0]);
    var listId = "collection_" + String(page.resourceId || window.location.pathname);
    var items = [];

    products.forEach(function (product, index) {
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var variant = variants[0] || {};
      var handle = cleanText(product.handle);
      if (!handle) return;
      items.push({
        item_id: cleanText(variant.sku) || String(variant.id || product.id || handle),
        item_name: productName(product, variant),
        item_brand: cleanText(product.vendor),
        item_category: cleanText(product.type),
        item_variant: cleanText(variant.public_title),
        price: Number(variant.price || 0) / 100,
        index: index,
        _path: "/products/" + handle
      });
    });

    return {
      item_list_id: listId,
      item_list_name: listName,
      items: items
    };
  }

  function publicItem(item) {
    var copy = {};
    Object.keys(item || {}).forEach(function (key) {
      if (key !== "_path" && item[key] !== "") copy[key] = item[key];
    });
    return copy;
  }

  function sendEvent(eventName, context, items) {
    if (typeof window.gtag !== "function") return false;
    window.gtag("event", eventName, {
      send_to: GA4_TAG_ID,
      item_list_id: context.item_list_id,
      item_list_name: context.item_list_name,
      items: items.map(publicItem)
    });
    return true;
  }

  function scheduleListView() {
    if (state.listScheduled) return;
    state.listScheduled = true;
    var attempts = 0;

    function waitForShopifyGoogleTag() {
      attempts += 1;
      var context = currentContext();
      if (
        context &&
        context.items.length &&
        typeof window.gtag === "function" &&
        hasDataLayerEvent("page_view")
      ) {
        window.setTimeout(function () {
          if (state.listSent || hasDataLayerEvent("view_item_list")) return;
          state.listSent = sendEvent("view_item_list", context, context.items);
        }, 1200);
        return;
      }
      if (attempts < 80) window.setTimeout(waitForShopifyGoogleTag, 250);
    }

    waitForShopifyGoogleTag();
  }

  function productLinkFromEvent(event) {
    var target = event && event.target;
    if (!target || !target.closest) return null;
    var link = target.closest("a[href*='/products/']");
    if (!link) return null;
    try {
      return { link: link, path: new URL(link.href, window.location.href).pathname.replace(/\/$/, "") };
    } catch (error) {
      return null;
    }
  }

  function sendSelection(event) {
    var match = productLinkFromEvent(event);
    if (!match || typeof window.gtag !== "function") return;
    var context = currentContext();
    if (!context) return;
    var item = context.items.find(function (candidate) {
      return candidate._path === match.path;
    });
    if (!item) return;

    var now = Date.now();
    if (state.lastSelectionPath === match.path && now - state.lastSelectionAt < 1500) return;
    state.lastSelectionPath = match.path;
    state.lastSelectionAt = now;
    sendEvent("select_item", context, [item]);
  }

  document.addEventListener("pointerdown", sendSelection, true);
  document.addEventListener("click", sendSelection, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleListView, { once: true });
  } else {
    scheduleListView();
  }
})();
